(function() {
	'use strict';
	angular.module('app.core')
		.controller('reportsExport', reportsExport);
	
	reportsExport.$inject = ['$uibModal', '$stateParams', 'reportsExportService'];
	
	function reportsExport($uibModal, $stateParams, reportsExportService) {
		var vm = this;
		vm.message = 'Your report will start downloading automatically...';
		var factoryId = $stateParams.factoryNdx;
		var reportId = $stateParams.reportId;		
		
		
		function startDownload() {
			var opts = {
				templateUrl: '/application/f/core/loading.html',
				windowClass: 'center-modal',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};
			var instance = $uibModal.open(opts);
			reportsExportService.startDownload(factoryId, reportId, instance, callback);
		}
		
		function init() {
			if (factoryId != null && reportId != null) {
				startDownload();
			}
		}
		
		function callback(html, success) {
			if (!success) {
				if (html.indexOf('Invalid request ID') >= 0 
						|| html.indexOf('This report is no longer available') >= 0) {
					vm.errorMessage = html;
				} else {
					vm.errorMessage = 'You are not authorized to download this report.';
				}
			} else {
				vm.message = html;
			}			
		}
		
		init();
	}
})();